import React, { Component } from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import PrimaryButton from 'components/PrimaryButton'

class Modal extends Component {
  constructor() {
    super()
    this.state = {
      open: false,
    }
  }

  componentWillMount() {
    document.body.style.overflow = 'hidden'
  }

  componentWillUnmount() {
    document.body.style.overflow = ''
  }

  render() {
    const {
      title,
      subtitle,
      custom,
      buttons,
      footer,
      iframed,
      side,
    } = this.props
    return (
      <Container className={this.props.className} iframed={iframed}>
        <Background
          onClick={this.props.closeOnBackground && this.props.onClick}
        />
        <AnimateShow className={'show'}>
          <ModalCard width={this.props.width}>
            <div style={{ flex: 1 }}>
              {!custom && (
                <CardHeader>
                  <CardTitle>
                    {title}
                    <br />
                    <Subtitle>{subtitle}</Subtitle>
                  </CardTitle>
                </CardHeader>
              )}
              <Close onClick={() => this.props.onClick(null)} />
              <CardBody custom={custom}>{this.props.children}</CardBody>
              {buttons && (
                <CardFooter>
                  {buttons.map((button) =>
                    button.primary ? (
                      <NextButton
                        key={button.label}
                        text={button.label}
                        onClick={button.click}
                      />
                    ) : (
                      <CancelButton
                        key={button.label}
                        text={button.label}
                        onClick={button.click}
                        color={button.color}
                      />
                    )
                  )}
                </CardFooter>
              )}

              {footer && <CardFooter>{footer}</CardFooter>}
            </div>
            {side && <SideInfo style={{ width: 350 }}>{side()}</SideInfo>}
          </ModalCard>
        </AnimateShow>
      </Container>
    )
  }
}

Modal.defaultProps = {
  toggle: false,
}

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ iframed }) => (iframed ? `9999999` : `1000`)};
  width: 100%;
  height: 100%;
  overflow: auto;
`

const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(1, 1, 1, 0.5);
`

const SideInfo = styled.div`
  background-image: linear-gradient(270deg, #006736 0%, #93c13e 100%);
  display: flex;
  align-items: center;
  jsutify-content: center;
`

const ModalCard = styled.div`
  ${({ width = 1020 }) => `
    max-width: ${width}px;
    min-width: ${width}px;
    left: calc(50% - ${width / 2}px);
  `}
  background-color: #FFFFFF;
  box-shadow: -2px 0 20px 0 rgba(0, 0, 0, 0.2);
  position: relative;
  top: 64px;
  display: flex;

  @media screen and (max-width: 768px) {
    min-width: initial;
    left: 0;
    top: 0;

    ${SideInfo} {
      display: none;
    }
  }
`

const CardHeader = styled.header`
  display: flex;
  padding: 32px;
  padding-right: 55px;
  justify-content: space-between;
`

const CardTitle = styled.h4`
  color: #010101;
  font-family: Nunito;
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  margin: 0;
  text-transform: uppercase;
`
const Close = styled.span`
  border: 1px solid #bababa;
  width: 24px;
  height: 24px;
  display: block;
  text-align: center;
  position: absolute;
  cursor: pointer;
  right: 32px;
  top: 32px;
  z-index: 33;

  &:before {
    content: '✕';
    font-size: 20px;
    line-height: 24px;
    color: #bababa;
    top: 0;
    position: absolute;
    left: 0;
    width: 100%;
  }
`

const CardBody = styled.div`
  ${({ custom }) =>
    !custom &&
    `
    padding: 0 32px;
  `}
`

const CardFooter = styled.footer`
  height: 80px;
  background-color: #efefef;
  box-shadow: inset 0 1px 0 0 #dedede;
  width: 100%;
  padding: 16px;
  text-align: right;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
`

const CancelButton = styled(Button)`
  width: 120px;
  margin-right: 16px;
`

const NextButton = styled(PrimaryButton)`
  width: 120px;
`

const AnimateShow = styled.div`
  transition: opacity 0.3s ease-in;
  opacity: 0;
  z-index: 1111;
  position: relative;

  &.show {
    opacity: 1;
  }
`

const Subtitle = styled.span`
  margin-left: 36px;
`

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/index.js